import React, { memo, useState } from "react"
import Img from "gatsby-image"
import InfoModal from "../components/InfoModal"

const CaseStudeiesTopSection = ({ headerData, data }) => {
    const [isModalVisible, setIsModalVisible] = useState(false)
    return (
        <div className="prod-hero">
            <div className="prod-hero__inner">
                <div className="prod-hero__text">
                    <span className="prod-hero__eyebrow">Product Overview</span>
                    <h1 className="prod-hero__title">{headerData.title}</h1>
                    <p className="prod-hero__desc">{headerData.peragraph}</p>
                    <button className="prod-hero__btn" onClick={() => setIsModalVisible(true)}>
                        Request a Demo
                    </button>
                </div>
                {data.HeaderImg && (
                    <div className="prod-hero__img">
                        <Img
                            fluid={data.HeaderImg.childImageSharp.fluid}
                            alt={headerData.title}
                            imgStyle={{ objectFit: "contain" }}
                        />
                    </div>
                )}
            </div>
            <InfoModal
                companyIsEnabled
                url="http://46.101.195.121:8066/email/ContactUs"
                isModalVisible={isModalVisible}
                handleOk={() => setIsModalVisible(false)}
                handleCancel={() => setIsModalVisible(false)}
            />
        </div>
    )
}
export default memo(CaseStudeiesTopSection)
